import React, {useEffect, useRef, useState} from "react";
import CarrouselCanales from "./carrouselCanales/carrouselCanales";
import "./canales.sass";


export default function Canales({ elementos }) {

    //------- INICIAR EJECUCION DE REZISE DEL COMPONENTE -------
    const envivoRef = useRef(null);
    const [load, setLoad] = useState(true);

    useEffect(() => {
        const resizeObserver = new ResizeObserver((entries) => {
            entries.forEach((entry) => {
                const newHeight = entry.contentRect.height;

                window.requestAnimationFrame(() => {
                    const message = {
                        sentinel: "amp",
                        type: "embed-size",
                        height: newHeight,
                    };
                    window.parent.postMessage(message, "*");
                });
            });
        });

        if (envivoRef.current) {
            resizeObserver.observe(envivoRef.current);
        }

        // Limpia el ResizeObserver al desmontar el componente
        return () => {
            resizeObserver.disconnect();
        };
    }, [envivoRef]);
    //------- TERMINA EJECUCION DE REZISE DEL COMPONENTE -------

    return (
        <div ref={envivoRef} className="container-sliderChanels" id="container-sliderChanels">
            {elementos.map((ele, indice) =>
                <div  className="container-chanel">
                    {!load && <a target="_top" href={ele.redirectChanel} className="title-chanel" style={{background : "#"+ele.colorBackground, color: "#"+ele.colorFont}}>{ele.nameChanel}</a>}
                    <CarrouselCanales chanelCode={ele.stationId} colorCanal={ele.colorFont} backgroundCanal={ele.colorBackground} activo={ele.active} channel={ele.nameChanel} setLoad={setLoad} elementos={ele}/>
                </div>
            )}
        </div>
    )
}